import React from 'react';
import './TrustBadge.css';

const TrustBadge = () => {
  return (
    <section className="trust-badge">
      <div className="trust-content">
        <h3>Trusted by 5 Lakh+ Families Across India</h3>
        <p>Making Every Celebration Extraordinary Since Day One</p>
      </div>
    </section>
  );
};

export default TrustBadge;
